// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vc-incoming-popup {
    position: fixed;
    top: 80px;
    right: 24px;
    width: 300px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    overflow: hidden;
    user-select: none;
}
.vc-incoming-drag-handle {
    height: 36px;
    line-height: 36px;
    padding: 0 14px;
    background: #722ed1;
    color: #fff;
    font-size: 14px;
    font-weight: 500;
    cursor: move;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.vc-incoming-drag-handle::before {
    content: '';
    width: 4px;
    height: 14px;
    background: #fff;
    border-radius: 2px;
    margin-right: 8px;
}
.vc-incoming-body {
    padding: 14px;
    text-align: center;
}
.vc-incoming-info {
    font-size: 15px;
    margin-bottom: 6px;
}
.vc-incoming-flow {
    font-size: 13px;
    color: #888;
    margin-bottom: 12px;
}
.vc-incoming-countdown {
    color: #ff4d4f;
    font-size: 13px;
    margin-bottom: 14px;
}
.vc-incoming-actions {
    display: flex;
    justify-content: center;
    gap: 16px;
}
`, "",{"version":3,"sources":["webpack://./client/components/VideoClaimIncoming/index.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb","sourcesContent":[".vc-incoming-popup {\r\n    position: fixed;\r\n    top: 80px;\r\n    right: 24px;\r\n    width: 300px;\r\n    background: #fff;\r\n    border-radius: 8px;\r\n    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);\r\n    z-index: 9999;\r\n    overflow: hidden;\r\n    user-select: none;\r\n}\r\n.vc-incoming-drag-handle {\r\n    height: 36px;\r\n    line-height: 36px;\r\n    padding: 0 14px;\r\n    background: #722ed1;\r\n    color: #fff;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    cursor: move;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n}\r\n.vc-incoming-drag-handle::before {\r\n    content: '';\r\n    width: 4px;\r\n    height: 14px;\r\n    background: #fff;\r\n    border-radius: 2px;\r\n    margin-right: 8px;\r\n}\r\n.vc-incoming-body {\r\n    padding: 14px;\r\n    text-align: center;\r\n}\r\n.vc-incoming-info {\r\n    font-size: 15px;\r\n    margin-bottom: 6px;\r\n}\r\n.vc-incoming-flow {\r\n    font-size: 13px;\r\n    color: #888;\r\n    margin-bottom: 12px;\r\n}\r\n.vc-incoming-countdown {\r\n    color: #ff4d4f;\r\n    font-size: 13px;\r\n    margin-bottom: 14px;\r\n}\r\n.vc-incoming-actions {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
